<template>
  <div class="autocomplete">
    <AutoCompleteResult
      v-if="autoCompleteItems && autoCompleteItems.length > 0"
      :autoCompleteItems="autoCompleteItems"
      :query="query"
      :currentSelectionIndex="currentSelectionIndex"
      @currentSuggestion="currentSuggestion"
      @currentSuggestionItem="currentSuggestionItem"
    >
    </AutoCompleteResult>
  </div>
  <div
    class="visually-hidden"
    role="status"
    aria-live="assertive"
    aria-relevant="additions"
  >
    {{ statusText }}
  </div>
</template>
<script>
import AutoCompleteResult from "./components/autocompleteresult.vue";

export default {
  name: "AutoComplete",
  props: {
    autoCompleteItems: Array,
    query: String,
    event: Object,
    texts: Object,
  },
  data: function () {
    return {
      statusText: "",
      currentSelectionIndex: 0,
      lastQuery: "",
      lastQueryItem: {},
    };
  },
  components: {
    AutoCompleteResult,
  },
  emits: ["currentSuggestion", "currentSuggestionItem"],
  methods: {
    onArrowDown() {
      if (this.currentSelectionIndex < this.autoCompleteItems.length) {
        this.currentSelectionIndex++;
      } else if (this.currentSelectionIndex == this.autoCompleteItems.length) {
        this.currentSelectionIndex = 0;
      }

      if (this.currentSelectionIndex == 0) {
        this.currentSuggestion("", false);
      }
    },
    onArrowUp() {
      if (this.currentSelectionIndex > 0) {
        this.currentSelectionIndex--;
      } else if (this.currentSelectionIndex == 0) {
        this.currentSelectionIndex = this.autoCompleteItems.length;
      }

      if (this.currentSelectionIndex == 0) {
        this.currentSuggestion("", false);
      }
    },
    onEnter() {
      if (this.currentSelectionIndex != 0) {
        this.currentSuggestion(this.lastQuery, true);
        this.currentSuggestionItem(this.lastQueryItem, true);
      } else if (this.autoCompleteItems.length == 1) {
        this.currentSuggestion(this.autoCompleteItems[0].value, true);
        this.currentSuggestionItem(this.autoCompleteItems[0], true);
      }
    },
    currentSuggestion(suggestion, click) {
      this.$emit("currentSuggestion", suggestion, click);
      this.lastQuery = suggestion;
    },
    currentSuggestionItem(suggestionItem, click) {
      this.$emit("currentSuggestionItem", suggestionItem, click);
      this.lastQueryItem = suggestionItem;
    },
    setStatusText() {
      if (this.autoCompleteItems && this.autoCompleteItems.length == 1) {
        this.statusText =
          "1 " +
          this.texts.sokforslagArTillgangligt +
          ", " +
          this.texts.anvandPiltangenterna;
      } else if (this.autoCompleteItems && this.autoCompleteItems.length > 1) {
        this.statusText =
          this.autoCompleteItems.length +
          " " +
          this.texts.sokforslagArTillgangliga +
          ", " +
          this.texts.anvandPiltangenterna;
      } else if (
        (!this.autoCompleteItems || this.autoCompleteItems.length == 0) &&
        this.query &&
        this.query.length != 0 &&
        this.lastQuery != this.query
      ) {
        this.statusText =
          this.statusText == this.texts.ingetHittades
            ? ""
            : this.texts.ingetHittades;
      } else {
        this.statusText = "";
        this.currentSelectionIndex = 0;
      }
      this.lastQuery = this.query;
    },
  },
  watch: {
    autoCompleteItems: {
      deep: true,
      handler() {
        this.setStatusText();
      },
    },
    event: {
      deep: true,
      handler(e) {
        if (e.key == "ArrowDown") {
          this.onArrowDown();
        } else if (e.key == "ArrowUp") {
          this.onArrowUp();
        } else if (e.key == "Enter") {
          this.onEnter();
        }
      },
    },
  },
};
</script>
